// extracted by mini-css-extract-plugin
module.exports = {"screen":"LatestEpisode_screen_2HR-l"};